import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { useEffect } from "react";

type AppPayStubsProps = {

}

export const AppPayStubs = ({} : AppPayStubsProps) => {
    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);
    const dispatch = useDispatch();
    
    
    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Pay Stubs"}));
    }, []);

    return (
        <div>
            <h1>Pay Stubs</h1>

            Coming soon...
        </div>
    )
}